const updateQuestions = {
  toastrTrue: 'Updated group',
  toastrFalse: 'Updated question',
  txt: ' has been updated successfully'
};

export default updateQuestions;
